export class Copy
{
    constructor(element)
    {
        this.element = element;
        this.text = this.element.dataset.text || this.element.dataset.target;
        this.textDefault = (element.innerText || '').trim();
        this.textCopied  = element.dataset.textCopied || 'Скопировано';

        this.timeoutSeconds = 1000;

        this.bindEvents();
    }

    bindEvents()
    {
        this.element.addEventListener('click', e => {
            e.preventDefault();
            this.copy();
        });
    }

    copy()
    {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        try {
            navigator.clipboard.writeText(this.text)
                .then(() => this.onSuccess())
                .catch(e => console.error(e));
        } catch (e) {
            const textarea = BX.Tag.render`
                <textarea style="position: fixed;left: -1000px;top: -1000px;"> 
                    ${ this.text }
                </textarea>`;

            BX.Dom.append(textarea, document.body);
            textarea.focus();
            textarea.select();

            if (document.execCommand('copy')) {
                this.onSuccess();
                BX.Dom.remove(textarea);
            }
        }
    }

    onSuccess()
    {
        this.element.innerText = this.textCopied;
        this.timeout = setTimeout(() => this.element.innerText = this.textDefault, this.timeoutSeconds);
    }
}

window.TextCopy = Copy;